import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MapItemComponent } from '@ui/shared/util-map';
import type { FoundingMapItemModel } from '../../entities/founding-map-item.model';
import { DetailContactComponent, DetailEmailLinkComponent, DetailViewModule } from '@ui/shared/ui-detail-view';
import { NewFoundingMapItemModel } from '../../entities/new-founding-map-item.model';

@Component({
    selector: 'ui-founding-map-item-details',
    imports: [
        DetailViewModule,
        DetailEmailLinkComponent,
        DetailContactComponent,
    ],
    templateUrl: './founding-map-item-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FoundingMapItemDetailsComponent
    implements MapItemComponent<FoundingMapItemModel> {
    public readonly mapItemTriggeredById = output<FoundingMapItemModel>();

    public mapItem = input<FoundingMapItemModel | undefined>();

    public get newFounding(): NewFoundingMapItemModel | undefined {
        const mapItem = this.mapItem();

        return mapItem instanceof NewFoundingMapItemModel ? mapItem : undefined;
    }

    public get newFoundingTags(): Array<string> {
        return this.newFounding ? [...this.newFounding.tags, `Gründungsjahr ${ this.newFounding.foundingYear }`] : [];
    }
}
